import { Box, Text } from '@chakra-ui/react';

interface StatCardProps {
  label: string;
  value: string;
  loading?: boolean;
}

export function StatCard({ label, value, loading = false }: StatCardProps) {
  return (
    <Box
      bg="volyx.bg"
      borderRadius="xl"
      boxShadow="0 1px 3px rgba(0, 0, 0, 0.08)"
      p="4"
      transition="all 0.3s"
      _hover={{ boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)', transform: 'scale(1.01)' }}
    >
      <Text fontSize="xs" fontWeight="medium" color="volyx.textSecondary" textTransform="uppercase" letterSpacing="wider" m="0">
        {label}
      </Text>
      <Text m="0" mt="1" fontSize="2xl" fontWeight="bold" color="volyx.primary">
        {loading ? '...' : value}
      </Text>
    </Box>
  );
}
